import { gql } from '@apollo/client';

export default gql`
  mutation uploadInspectionSubjectFile($inspectionSubjectId: ID!, $file: Upload!) {
    uploadInspectionSubjectFile(input: { inspectionSubjectId: $inspectionSubjectId, file: $file }) {
      externalFile {
        id
        filename
        contentType
        fileSize
        externalUrl
        isImage
        isPdf
        fileExtension
      }
    }
  }
`;
